import '../../containers/Accordion/Accordion.css'

const NewsLink =(props) =>{
    let newsDate = new Date(props.data.MODNewsPublishDate);
    return(
        // <div className="title modCard-header" id={"accHead_" + props.WpId +"_"+ props.index} >
        //     <h3 className="mb-0">
        //         <a className="btn btn-link" href={props.moreLink +"?itemId="+ props.data.ID} title="">
        //             <div className="itemTitle">
        //                 <div className="titleHour">
        //                     <div className="title">{props.data.Title}</div>
        //                     {newsDate} 
        //                 </div>
        //                 <span className="fas fa-chevron-left" aria-hidden="true"> </span>
        //             </div>
        //          </a>
        //     </h3> 
        // </div>

        <li className="LinkItem col-12 col-md-4" key={"NewsLink_"+index}>
            <a href={props.moreLink +"?itemId="+ props.data.ID} title="להודעה">
                <div className="LinkTitle">
                    <div className="newsTitle">{props.data.Title}</div> 
                    <div className="dateHour">
                        <div className="title">{newsDate.toLocaleDateString('he-IL')}</div>
                        <div className="hour"><span>{newsDate.getHours()+":"+newsDate.getMinutes()} </span></div>
                    </div> 
                </div>  
            </a>
            <div className="yellowCorner"></div>
        </li>
    )
}
export default NewsLink


             